import React from "react";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import * as client from "../../../client";
import { readableNameFromPeril } from "../general-input/util";
import { togglePeril, isPerilLocked } from "./perilRules";
import styles from "./PolicyTermControls.module.css";

type Perils = client.PolicyInfo["included_perils"];
type FormSel = NonNullable<client.PolicyInfo["form_selection"]>;

const FORM_OPTIONS: FormSel[] = ["Co-Participation", "Manuscript"];

// Shared policy-term controls, used by the General tab (writes report
// policy_info) and the layer modal (writes a layer override). They own the
// value/onChange contract; callers decide where the value is stored.

export const PerilCheckboxes: React.FC<{
  value: Perils;
  onChange: (perils: Perils) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => (
  <>
    {Object.values(client.peril_type).map((peril) => (
      <div className={styles.row} key={peril}>
        <div className={styles.label}>{readableNameFromPeril(peril)}</div>
        <Checkbox
          checked={value.includes(peril)}
          disabled={disabled || isPerilLocked(value, peril)}
          onChange={(e) => onChange(togglePeril(value, peril, !!e.checked))}
        />
      </div>
    ))}
  </>
);

export const FormSelectionDropdown: React.FC<{
  value: FormSel | null;
  onChange: (value: FormSel | null) => void;
  disabled?: boolean;
  // Callers that render their own label (e.g. with an override indicator).
  hideLabel?: boolean;
}> = ({ value, onChange, disabled, hideLabel }) => (
  <>
    {!hideLabel && <span className={styles.label}>Policy Type</span>}
    <Dropdown
      disabled={disabled}
      options={FORM_OPTIONS}
      value={value}
      onChange={(e) => onChange(e.value ?? null)}
      showClear
      style={{ maxWidth: "440px" }}
    />
  </>
);

export const BrokerCommissionInput: React.FC<{
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  hideLabel?: boolean;
}> = ({ value, onChange, disabled, hideLabel }) => (
  <>
    {!hideLabel && <span className={styles.label}>Broker Commission (%)</span>}
    <InputNumber
      disabled={disabled}
      value={value ?? null}
      onChange={(e) => onChange(e.value ?? null)}
      suffix="%"
      minFractionDigits={0}
      maxFractionDigits={2}
      min={0}
      max={100}
      style={{ maxWidth: "440px" }}
    />
  </>
);
